/**
 * 路由
 */
export default {
  routes: [{
    path: '/',
    redirect: '/qrcode'
  },
  // { // 租车页
  //   path: '/rent',
  //   name: 'rent',
  //   // component: Rent,
  //   component: resolve => import(/* webpackChunkName: "Rent" */'../modules/rent/Rent').then(resolve),
  //   meta: {
  //     title: '预约租车'
  //   }
  // }, { // 预约页
  //   path: '/book',
  //   name: 'book',
  //   // component: Book,
  //   component: resolve => import(/* webpackChunkName: "Book" */'../modules/book/Book').then(resolve),
  //   meta: {
  //     title: '预约雷克萨斯'
  //   }
  // }, { // 成功页
  //   path: '/success',
  //   name: 'success',
  //   // component: Success,
  //   component: resolve => import(/* webpackChunkName: "Success" */'../modules/success/Success').then(resolve),
  //   meta: {
  //     title: '预约租车成功'
  //   }
  // },
  { // 增加扫码页面口令
    path: '/checked',
    name: 'checked',
    component: resolve => import(/* webpackChunkName: "QrCode" */'../modules/coupon/checked').then(resolve)
  },
  { // 扫码页面
    path: '/qrCode',
    name: 'qrCode',
    component: resolve => import(/* webpackChunkName: "QrCode" */'../modules/coupon/qrCode').then(resolve)
  }, { // 领取优惠券
    path: '/receCoupon',
    name: 'receCoupon',
    component: resolve => import(/* webpackChunkName: "QrCode" */'../modules/coupon/receCoupon').then(resolve)
  }]
}




// WEBPACK FOOTER //
// ./src/router/config.js